enum Sections {
  flows = "flows",
  assets = "assets",
  assessments = "assessments",
  emails = "emails",
  messages = "messages",
  events = "events",
  surveys = "surveys",
  pdfs = "pdfs",
  tdf = "threat_defence_campaigns",
}
export default Sections;
